import { Component, OnInit, EventEmitter } from '@angular/core';
import { ActivityView } from '../../../../../views/master-views/app.view/app.view.component';
import { Activity, ActivityModel } from '../../../../../models/activities';
import { FormGroup } from '@angular/forms';
import { WorkflowContextService } from '../../../../../services';

@Component({
    selector: 'wm-contractor-registration-info-form-activity-view',
    templateUrl: './contractor-registration-info-form-activity-view.component.html',
    styleUrls: ['./contractor-registration-info-form-activity-view.component.css'],
    standalone: false
})
export class ContractorRegistrationInfoFormActivityViewComponent
  extends ActivityView
  implements OnInit {
  viewTitle(): string {
    return 'Contractor Registration Info';
  }

  constructor() {
    super();
  }

  ngOnInit() {}
}
